/* eslint-disable */
export const HorseStatus = {
    NEW_FOAL: "NEW_FOAL",
    NEW_IMPORTED: "NEW_IMPORTED",
    WAITING_FOR_MARKING_DATA: "WAITING_FOR_MARKING_DATA",
    WAITING_FOR_LABORATORY: "WAITING_FOR_LABORATORY",
    LABORATORY_DATA_ENTERED: "LABORATORY_DATA_ENTERED",
    REGISTER_IN_STUDBOOK: "REGISTER_IN_STUDBOOK",
    REJECTED: "REJECTED",
    EXTERNAL: "EXTERNAL",
};
